<div class="wrapper d-flex flex-column">
    <div class="header d-flex row align-items-center">
        <div class="col-md-6">
            <h6 class="px-4 py-3">Size Filter Management</h6>
        </div>
        <div class="header-action-btn col-md-6 d-flex align-items-center justify-content-end pr-2">
            <!-- <button class="margin-right" nz-button nzType="default">Reset</button>

            <button class="margin-right" nz-button nzType="primary">Update</button> -->
            <button nz-button nzType="primary" [disabled]="!selectedLot" (click)="linkDrawer = !linkDrawer">Add Size
                Filter</button>
        </div>
    </div>
    <div class="form-container px-4 row g-3">
        <div class="col-md-12">
            <h6 class="px-0">Search Lot</h6>
        </div>
        <div class="row d-flex align-items-center">
            <div class="col-md-10 mb-2 d-flex flex-column position-relative">
                <label class="form-label">Lot Id<span class="text-danger">*</span></label>
                <nz-select nzPlaceHolder="Select Lot Id" nzSize="default" [(ngModel)]="selectedLot"
                    style="height: 38px !important;width: 100%;" [nzShowSearch]="true"  class="uppercase-select"
                    >
                    @for(lot of assoctLots; track lot.lotId){
                    <nz-option nzCustomContent [nzLabel]="lot.lotId+ ' - ' +lot.lotDescription" [nzValue]="lot.lotId">
                        <div class="lot-content">
                            <span>{{ lot.lotId }} - {{ lot.lotDescription }}</span>
                            <nz-tag [nzColor]="'orange'">Sizes Filtered - {{lot.countOfSizes}}</nz-tag>
                        </div>
                    </nz-option>
                    }
                </nz-select>
                <span class="error-text" *ngIf="inValidSearch && !selectedLot">
                    *Lot ID is required.
                </span>
            </div>
            <div class="col-md-2 mt-3 d-flex px-4">
                <button class="margin-right" nz-button nzType="primary" (click)="searchLotSizes()">Search</button>
            </div>
        </div>

        <ng-container *ngIf="assctLotSizes">
            <app-data-grid [columns]="lotSizeColumns" [dataSet]="assctLotSizes" [gridStyle]="'white'"
                (deleteRow)="deleteRow($event)" [frontPagination]="false"></app-data-grid>
        </ng-container>
    </div>
</div>
<nz-drawer [nzMaskClosable]="false" [nzWidth]="830" [nzKeyboard]="false" [nzVisible]="linkDrawer" nzTitle="Add New Size"
    (nzOnClose)="linkDrawer = false;">
    <ng-container *nzDrawerContent>
        <app-add-lot-size #drawerRef (emitAddData)="addLot($event)" [catalogId]="catalogId"
            [selectedLot]="selectedLot"></app-add-lot-size>
    </ng-container>
</nz-drawer>